import { createMuiTheme } from '@material-ui/core/styles';

const themes = {
  'monochrome': createMuiTheme({
    palette: {
      type: 'light',
      primary: { main: '#000000' },
      secondary: { main: '#ffffff' },
      background: { default: '#ffffff', paper: '#f5f5f5' },
      text: { primary: '#000000', secondary: '#333333' }
    },
    typography: { fontFamily: 'Inter, sans-serif' }
  }),
  'bauhaus': createMuiTheme({
    palette: {
      type: 'light',
      primary: { main: '#FF0000' },
      secondary: { main: '#0000FF' },
      background: { default: '#F0F0F0', paper: '#ffffff' },
      text: { primary: '#1A1A1A' }
    },
    typography: { fontFamily: 'Futura, sans-serif' }
  }),
  'modern-dark': createMuiTheme({
    palette: {
      type: 'dark',
      primary: { main: '#38BDF8' },
      secondary: { main: '#1E293B' },
      background: { default: '#0F172A', paper: '#1E293B' },
      text: { primary: '#F8FAFC', secondary: '#94A3B8' }
    },
    typography: { fontFamily: 'Inter, sans-serif' }
  }),
  'newsprint': createMuiTheme({
    palette: {
      type: 'light',
      primary: { main: '#1A1A1A' },
      secondary: { main: '#CC0000' },
      background: { default: '#FDFBF7', paper: '#ffffff' },
      text: { primary: '#1A1A1A' }
    },
    typography: { fontFamily: 'Merriweather, serif' }
  }),
  'saas': createMuiTheme({
    palette: {
      type: 'light',
      primary: { main: '#3B82F6' },
      secondary: { main: '#111827' },
      background: { default: '#ffffff', paper: '#F3F4F6' },
      text: { primary: '#111827', secondary: '#6B7280' }
    },
    typography: { fontFamily: 'Inter, sans-serif' }
  }),
  'luxury': createMuiTheme({
    palette: {
      type: 'light',
      primary: { main: '#D4AF37' },
      secondary: { main: '#0A0A0A' },
      background: { default: '#F4F1EA', paper: '#ffffff' },
      text: { primary: '#0A0A0A' }
    },
    typography: { fontFamily: 'Didot, serif' }
  }),
  'terminal': createMuiTheme({
    palette: {
      type: 'dark',
      primary: { main: '#00FF00' },
      secondary: { main: '#003300' },
      background: { default: '#000000', paper: '#050505' },
      text: { primary: '#00FF00', secondary: '#008F00' }
    },
    typography: { fontFamily: 'Courier New, monospace' }
  }),
  'swiss-minimalist': createMuiTheme({
    palette: {
      type: 'light',
      primary: { main: '#FF3333' },
      secondary: { main: '#000000' },
      background: { default: '#FFFFFF', paper: '#EEEEEE' },
      text: { primary: '#000000' }
    },
    typography: { fontFamily: 'Helvetica, sans-serif' }
  }),
  'kinetic': createMuiTheme({
    palette: {
      type: 'dark',
      primary: { main: '#CCFF00' },
      secondary: { main: '#FF00FF' },
      background: { default: '#000000', paper: '#111111' },
      text: { primary: '#FFFFFF' }
    },
    typography: { fontFamily: 'Monument Extended, sans-serif' }
  }),
  'flat-design': createMuiTheme({
    palette: {
      type: 'light',
      primary: { main: '#3498DB' },
      secondary: { main: '#2ECC71' },
      background: { default: '#ECF0F1', paper: '#ffffff' },
      text: { primary: '#2C3E50' }
    },
    typography: { fontFamily: 'Lato, sans-serif' }
  })
};

export default themes;
